import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import {
  faQuestion,
  faQuestionSquare,
  faSquareQuestion,
  faMessagesQuestion,
  faCloudQuestion,
  faClipboardQuestion,
  faFileCircleQuestion,
  faShredder,
  faPersonCircleQuestion,
  faFile,
  faFiles,
  faFileExport,
  faFileCircleInfo,
  faFileSpreadsheet,
  faFileMagnifyingGlass,
  faFileSignature,
  faFileLines,
  faEnvelope,
  faFileExclamation,
  faFileCheck,
  faFileSlash,
  faFileShield,
  faFilePen,
  faFileLock,
  faFilesMedical,
  faFileContract,
  faFileInvoiceDollar,
  faFileUser,
  faFileCertificate,
  faLaptopFile,
} from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ExampleKimQuestion } from '../../../../../../../../backend/src/case/thread/example-question';
import { TrackingEvents } from '@/analytics/events';
import { trackCustomEvent } from '@/analytics/Mixpanel';

const getFontAwesomeIcon = (icon: string): IconProp => {
  return ({
    question: faQuestion,
    questionBlock: faQuestionSquare,
    squareQuestion: faSquareQuestion,
    messagesQuestion: faMessagesQuestion,
    cloudQuestion: faCloudQuestion,
    clipboardQuestion: faClipboardQuestion,
    fileCircleQuestion: faFileCircleQuestion,
    shredder: faShredder,
    personCircleQuestion: faPersonCircleQuestion,
    file: faFile,
    files: faFiles,
    fileExport: faFileExport,
    fileCircleInfo: faFileCircleInfo,
    fileSpreadsheet: faFileSpreadsheet,
    fileMagnifyingGlass: faFileMagnifyingGlass,
    fileSignature: faFileSignature,
    fileLines: faFileLines,
    envelope: faEnvelope,
    fileExclamation: faFileExclamation,
    fileCheck: faFileCheck,
    fileSlash: faFileSlash,
    fileShield: faFileShield,
    filePen: faFilePen,
    fileLock: faFileLock,
    filesMedical: faFilesMedical,
    filesContract: faFileContract,
    fileInvoiceDollar: faFileInvoiceDollar,
    fileUser: faFileUser,
    fileCertificate: faFileCertificate,
    laptopFile: faLaptopFile,
  }[icon] ?? faQuestion) as IconProp;
};

interface ExampleQuestionsProps {
  questions: ExampleKimQuestion[];
  onQuestionClick: (question: string) => void;
}

export const ExampleQuestions = ({ questions, onQuestionClick }: ExampleQuestionsProps) => {
  if (questions.length === 0) return null;

  return (
    <div className="space-y-2 text-xs">
      {questions.map((item, index) => (
        <div
          key={index}
          onClick={() => {
            trackCustomEvent(TrackingEvents.KimOnboardingClickExampleQuestion);
            onQuestionClick(item.prompt);
          }}
          className={`group flex cursor-pointer items-center justify-between rounded-lg border border-gray-200 bg-gray-50 p-3 text-left transition-all hover:border-purple-300 hover:bg-purple-50 hover:shadow-md`}
        >
          <div className="flex items-center gap-3">
            <FontAwesomeIcon icon={getFontAwesomeIcon(item.icon)} className="place-self-center text-lg text-gray-600" />
            <div className="flex-1">
              <p className="text-gray-900">{item.prompt}</p>
            </div>
          </div>
          <FontAwesomeIcon
            icon={faArrowRight}
            className={`h-4 w-4 text-purple-500 opacity-0 transition-opacity group-hover:opacity-100`}
          />
        </div>
      ))}
    </div>
  );
};
